import { useGameStore } from '../game/store';
import { Biome, BIOME_DISPLAY } from '../game/engine/types';
import { startTickLoop, stopTickLoop } from '../game/store';

export function HUD(): JSX.Element {
  const world = useGameStore((s) => s.world);
  const togglePause = useGameStore((s) => s.togglePause);
  const quitGame = useGameStore((s) => s.quitGame);

  return (
    <div className="hud">
      <div className="hud-row hud-top">
        <div className="hud-block score-block">
          <div className="hud-label">Score</div>
          <div className="hud-value">{world.score}</div>
          {world.combo > 1 && (
            <div className="combo-badge">x{world.combo}</div>
          )}
        </div>
        <div className="hud-block hud-metrics">
          <div className="hud-label">Length</div>
          <div className="hud-value">{world.snakeLength}</div>
        </div>
        <div className="hud-block hud-level">
          <div className="hud-label">Level {world.level}</div>
          <div className="progress">
            <div
              className="progress-bar"
              style={{ width: `${world.levelProgress * 100}%` }}
            />
          </div>
        </div>
        <div className="hud-block hud-biome">
          <div className="hud-label">{BIOME_DISPLAY[world.biome as Biome]}</div>
        </div>
        <div className="hud-actions">
          <button
            onClick={() => {
              stopTickLoop();
              togglePause();
              startTickLoop();
            }}
            aria-label="Pause"
          >
            {world.status === 'PAUSED' ? '▶' : '❚❚'}
          </button>
          <button onClick={quitGame} aria-label="Quit">✕</button>
        </div>
      </div>
    </div>
  );
}
